import React from "react";
import { T } from "react-translator-component";
import { i18nValue } from "../../functions";
import MenuCommerceItemCard from "./MenuCommerceItemCard";

const MenuCommerceList = ({
  menu,
  language,
  currency,
  quantities,
  itemAppearance,
  addItem,
  removeItem,
  filterItems,
  showSearch = true,
  searchTerm = "",
  setSearchTerm,
  showCategories = true,
  activeCategoryIndex = 0,
  setActiveCategoryIndex,
  showBuyButton = true,
}) => {
  if (!menu?.content?.length) {
    return null;
  }

  const renderSection = (section, index, forceTitle = false) => {
    const items = filterItems(section?.items || []);
    if (!items.length) {
      return null;
    }

    return (
      <div key={section.id || index} className="mb-4">
        {forceTitle ? (
          <>
            <h6 className="section-title">{i18nValue(section, "title", language)}</h6>
            <p className="section-description">{i18nValue(section, "description", language)}</p>
          </>
        ) : null}

        {items.map((item) => (
          <MenuCommerceItemCard
            key={item.id}
            item={item}
            quantity={Number(quantities[item.id] || 0)}
            language={language}
            currency={currency}
            appearance={itemAppearance}
            onAdd={addItem}
            onRemove={removeItem}
            showBuyButton={showBuyButton}
          />
        ))}
      </div>
    );
  };

  return (
    <>
      {(showSearch || showCategories) && (
        <div className="menu-commerce-toolbar">
          {showSearch ? (
            <div className="menu-commerce-search-shell">
              <span className="menu-commerce-search-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path
                    d="M10.5 4a6.5 6.5 0 1 0 4.03 11.6l4.43 4.43 1.41-1.41-4.43-4.43A6.5 6.5 0 0 0 10.5 4Zm0 2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <input
                type="text"
                className="menu-commerce-search-input"
                placeholder={T("menu.search_room_service")}
                value={searchTerm}
                onChange={(event) => setSearchTerm?.(event.target.value)}
              />
            </div>
          ) : null}

          {showCategories ? (
            <div className="menu-commerce-categories">
              <button
                type="button"
                className={`menu-commerce-category-chip ${activeCategoryIndex === 0 ? "is-active" : ""}`}
                onClick={() => setActiveCategoryIndex?.(0)}
              >
                {T("menu.all")}
              </button>
              {menu.content.map((section, index) => (
                <button
                  key={section.id || index}
                  type="button"
                  className={`menu-commerce-category-chip ${activeCategoryIndex === index + 1 ? "is-active" : ""}`}
                  onClick={() => setActiveCategoryIndex?.(index + 1)}
                >
                  {i18nValue(section, "title", language) || `${T("menu.category")} ${index + 1}`}
                </button>
              ))}
            </div>
          ) : null}
        </div>
      )}

      {activeCategoryIndex === 0
        ? menu.content.map((section, index) => renderSection(section, index, showCategories))
        : menu.content
            .filter((_, index) => index === activeCategoryIndex - 1)
            .map((section, index) => renderSection(section, index, true))}
    </>
  );
};

export default MenuCommerceList;
